/**
 * The ceiling cabinet trim measures its gap to: the room's, as the run engine
 * reads it (`materializeRun.roomCeilingY` over the room's floor) — so the
 * uppers' line and their crown agree, and the estimate and the 3D view ask
 * the same height. Pure.
 */
const { roomCeilingY } = require('../cabinet-runs/materializeRun');
const { getFloorY } = require('../vanity-assembly/placementUtils');

const trimCeilingY = (room) => roomCeilingY(room, getFloorY(room));

module.exports = { trimCeilingY };
